// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Fydv","location":"Header_location__3bAX4"};